import { Globe } from 'lucide-react';
import { useArtifactPanelStore } from '@/stores/artifactPanelStore.js';
import { Section } from './Section.js';
import { ArtifactItem } from './ArtifactItem.js';

export function BrowserSection() {
  const sections = useArtifactPanelStore((state) => state.sections);
  const toggleSection = useArtifactPanelStore((state) => state.toggleSection);
  const getArtifactsByType = useArtifactPanelStore((state) => state.getArtifactsByType);
  const openTab = useArtifactPanelStore((state) => state.openTab);
  const togglePin = useArtifactPanelStore((state) => state.togglePin);
  const deleteArtifact = useArtifactPanelStore((state) => state.deleteArtifact);
  const openBrowser = useArtifactPanelStore((state) => state.openBrowser);
  const activeTabId = useArtifactPanelStore((state) => state.activeTabId);
  const openTabs = useArtifactPanelStore((state) => state.openTabs);
  const searchQuery = useArtifactPanelStore((state) => state.searchQuery);

  let browserArtifacts = getArtifactsByType('browser');

  // Filter by search query
  if (searchQuery) {
    browserArtifacts = browserArtifacts.filter((artifact) =>
      artifact.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      artifact.metadata?.url?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  // Sort browsers
  const sortBy = sections.browser.sortBy;
  browserArtifacts = [...browserArtifacts].sort((a, b) => {
    if (sortBy === 'modified') {
      return b.modifiedAt - a.modifiedAt;
    } else if (sortBy === 'created') {
      return b.createdAt - a.createdAt;
    } else {
      return a.title.localeCompare(b.title);
    }
  });

  return (
    <Section
      title="Browser"
      icon={<Globe className="h-3.5 w-3.5 text-muted-foreground" />}
      count={browserArtifacts.length}
      collapsed={sections.browser.collapsed}
      onToggle={() => toggleSection('browser')}
      onNew={() => openBrowser('', 'Browser')}
    >
      {browserArtifacts.length === 0 ? (
        <div className="px-3 py-2 text-xs text-muted-foreground">
          No browser tabs yet. Click + to create one.
        </div>
      ) : (
        browserArtifacts.map((artifact) => (
          <ArtifactItem
            key={artifact.id}
            artifact={artifact}
            isActive={activeTabId === artifact.id}
            isOpen={openTabs.includes(artifact.id)}
            onClick={() => openTab({ id: artifact.id, type: artifact.type, title: artifact.title, data: artifact.data })}
            onPin={() => togglePin(artifact.id)}
            onDelete={() => deleteArtifact(artifact.id)}
          />
        ))
      )}
    </Section>
  );
}
